module.exports = __webpack_public_path__ + "static/media/AdmisionesNormales.148d0afc.svg";